/*=========================================================================================
  File Name: moduleStock.js
  Description: Supplier Module
  ----------------------------------------------------------------------------------------
  Item Name: POS SYSTEM
  Author: SpeedCodeLabs
  Author URL: http://www.speedcodelabs.com
==========================================================================================*/

import actions from './moduleSmsActions.js';

export default {
  namespaced: true,
  actions,
};
